class FooterElement extends HTMLElement {
  connectedCallback() {
    this.observeDOMChanges();
  }

  /**
   * Scroll to the bottom of the page.
   * @returns {void}
   */
  scrollToBottom() {
    window.scrollTo({
      top: document.body.scrollHeight || document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  }

  /**
   * Observe DOM changes and scroll to bottom when new content is added.
   * @returns {void}
   */
  observeDOMChanges() {
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0 && this.checkURLAndScroll()) {
          this.scrollToBottom();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Check if the URL contains a specific query parameter and hash after suc
   * @returns {boolean}
   */
  checkURLAndScroll() {
    const url = new URL(globalThis.location.href);
    const searchParameters = url.searchParams;
    const hash = url.hash;

    if (
      searchParameters.has('customer_posted') &&
      searchParameters.get('customer_posted') === 'true' &&
      hash === '#footer-newsletter'
    ) {
      this.scrollToBottom();
    }
  }
}

customElements.get('footer-element') ||
  customElements.define('footer-element', FooterElement);
